import registrationApi from './registrationApi';

export const resendConfirmationEmail = (resendConfirmationEmailApiProvider = registrationApi) => {
  return async (
    resendConfirmationEmailUrl,
    {
      setResendStatus = () => null,
      emailToken = null,
    } = {},
  ) => {
    try {
      setResendStatus('loading');
      const { status } = await resendConfirmationEmailApiProvider(
        resendConfirmationEmailUrl,
        { emailUrlToken: emailToken },
      );

      if (status !== 200) {
        throw error;
      }

      setResendStatus('success');

      setTimeout(() => {
        setResendStatus('default');
      }, 1500);
    } catch (error) {
      setResendStatus('error');
      console.error(error)
    }
  };
};

export default resendConfirmationEmail(registrationApi);
